import React, { useState, useEffect } from 'react'
import {
    Grid,
    Typography,
    Button,
    IconButton,
    TextField,
    List,
    ListItem,
    ListItemText,
    Slider,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
} from '@material-ui/core'
import { Link } from '@reach/router'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import Dialog from '../../dialog'
import { getCurrentUser } from '../../../firebase/obj/user'
import { loginWithGoogle } from '../../../firebase/login'
import Notification from '../../notification'
import InputNumber from '../../inputNumber'
import { useStyles } from './clientStyles'
import OrderProductEdit from '../orderProductEdit'
import { generateSmartComposition } from '../../../utils/productEdit'
import PaymentMethod from './payment'
import PickupOptions from './pickupOptions'
import useMainContext from '../../../hooks/useMainContext'
import SmartNotes from '../smartNotes'
import ScheduleOrder from '../orderSchedule'
import { getBusinessScheduleStatus } from '../../../utils/dateFunctions'
import moment from 'moment'
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'


const voidF = () => { }
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL
const mercadopagoPublicKey = process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY;

export const ClientOrderForm = ({
    client,
    clientPoints = 0,
    order,
    notification,
    setOrder = voidF,
    setProductQty = voidF,
    sendOrder = voidF,
    deleteProduct = voidF,
    usedPointsHandler = voidF,
    addresses,
    setOpenAddressForm = voidF,
    paymentMethods = [],
    mercadopagoPreferenceId, // New prop
    finalizeOrderAfterMP,   // New prop
    clearMercadoPagoPreferenceId // New prop
}) => {
    const classes = useStyles()
    const [disabled, setDisabled] = useState(true)
    const [isMPInitializing, setIsMPInitializing] = useState(false)
    const [editLineOpen, setEditLineOpen] = useState(false)
    const [lineToEdit, setLineToEdit] = useState({})
    const [selectedAddress, setSelectedAddress] = useState('')
    const [dialog, setDialog] = useState({
        open: false,
        message: ''
    })
    const [usedPoints, setUsedPoints] = useState(0)
    const { config, businessInfo, user } = useMainContext()
    const [localOpen, setLocalOpen] = useState(true)
    const [isOpenSoon, setIsOpenSoon] = useState(false)

    const [notificationOpen, setOpen] = useState(false)
    const [autoHideDuration, setAutoHideDuration] = useState(3000)
    const [severity, setSeverityState] = useState('success')
    const [notificationMessage, setNotificationMessageState] = useState('')
    const [businessStatus, setBusinessStatus] = useState({
        isOpen: false,
        openSoon: false,
        message: 'El local se encuentra cerrado',
        nextOpening: null,
        hoursToOpen: null
    })

    // useEffect(() => {
    //     if (mercadopagoPublicKey && order.paymentMethod === 'mercadopago' && !isMPInitializing) {
    //         setIsMPInitializing(true);
    //         initMercadoPago(mercadopagoPublicKey, { locale: 'es-UY' }); // Or your specific locale
    //         // console.log('Mercado Pago Initialized');
    //         // setIsMPInitializing(false); // Not really needed to set false, just indicates it has been called
    //     }
    // }, [mercadopagoPublicKey, order.paymentMethod, isMPInitializing]);

    useEffect(() => {
        console.log('useEffect mercadopagoPreferenceId', mercadopagoPreferenceId)
        // If payment method changes away from mercadopago and a preferenceId exists, clear it
        if (order.paymentMethod !== 'mercadopago' && mercadopagoPreferenceId && clearMercadoPagoPreferenceId) {
            clearMercadoPagoPreferenceId();
        }
    }, [order.paymentMethod, mercadopagoPreferenceId, clearMercadoPagoPreferenceId]);


    useEffect(() => {
        if (businessInfo) {
            const _businessStatus = getBusinessScheduleStatus(businessInfo)
            setLocalOpen(_businessStatus.isOpen)
            setBusinessStatus(_businessStatus)
            if (config) {
                const { canScheduleOrder, canScheduleBeforeHours = 4 } = config
                // console.log('canScheduleOrder', canScheduleOrder)
                // console.log('canScheduleBeforeHours', canScheduleBeforeHours)
                // console.log('bussinesStatus', _businessStatus)
                // console.log('hoursToOpen', _businessStatus.hoursToOpen)
                // console.log('openSoon', _businessStatus.openSoon)
                if (!_businessStatus.isOpen && _businessStatus.openSoon && canScheduleOrder && _businessStatus.hoursToOpen <= canScheduleBeforeHours) {
                    setIsOpenSoon(true)
                }
            }
        }
    }, [businessInfo, config])

    useEffect(() => {
        if (!notification.message)
            return setOpen(false)

        setOpen(notification.open)
        setAutoHideDuration(notification.autoHideDuration)
        setSeverityState(notification.severity)
        setNotificationMessageState(notification.message)
    }, [notification])

    // Use prop functions for notifications
    const setNotificationOpen = (isOpen) => setOpen(isOpen);
    const setNotificationMessage = (message) => setNotificationMessageState(message);
    const setSeverity = (severityType) => setSeverityState(severityType);


    useEffect(() => {
        disableControl()
        if (editLineOpen) {
            const { productsList = [] } = order
            const product = productsList?.find(p => p.id === lineToEdit.id)
            if (product) {
                //console.log('useEffect order product', product)
                const smartComposition = generateSmartComposition(product).smartComposition
                setLineToEdit({ ...product, smartComposition })
            }
        }
        //setSelectedAddress(order?.addressId || addresses.find(e => e.principal)?.id || '')
        // console.log('order', order)
        setSelectedAddress(order?.addressId || '')
    }, [order, addresses, config, localOpen, client])

    const disableControl = () => {
        let _disabled = false

        if (order.productsList?.length < 1) _disabled = true
        if (!user) _disabled = true
        if (!order.paymentMethod && paymentMethods?.length > 0) _disabled = true
        if (config?.requirePhoneValidation && !user?.phoneNumber) _disabled = true
        if (!businessStatus.isOpen && !businessStatus.openSoon) _disabled = true
        if (businessStatus.openSoon && !order.scheduled) _disabled = true

        setDisabled(_disabled)
    }

    const handleConfirmLineEdit = (prod) => {
        const { productsList } = order
        const _productsList = productsList?.map(product => {
            if (prod.id === product.id)
                return { ...prod }
            return { ...product }
        })
        setOrder({
            ...order,
            productsList: _productsList
        })
    }

    const handleEditProduct = product => {
        const smartComposition = generateSmartComposition(product).smartComposition
        setLineToEdit({ ...product, smartComposition })
        setEditLineOpen(true)
    }

    const handleDeleteProduct = (product) => {
        setDialog({
            open: true,
            message: `¿Desea borrar ${product.name || product.description || 'elemento'}?`,
            obj: product,
        })
    }

    const getProductQty = (product) => {
        const { productsList } = order
        const _prod = productsList?.find(prod => prod.id === product.id)
        const { qty = 0 } = _prod || {}
        return Number(qty || 0)
    }

    const setDialogOpen = open => setDialog({ ...dialog, open })

    const changeUsedPoints = (event, points) => setUsedPoints(points)

    const changeUsedPointsCommited = event => usedPointsHandler(order, usedPoints)

    const handleChangeAddress = (event) => {
        const addressId = event.target.value
        setSelectedAddress(addressId)
        setOrder({
            ...order,
            addressId
        })
    }

    const calculateMax = () => {
        const { amount = 0, usedPoints = 0 } = order
        let max = amount + usedPoints
        if (max > clientPoints) {
            return clientPoints
        }
        return max
    }
    const handleChangePickup = () => {
        const _pickup = !order.pickup
        if (_pickup) {
            //si seteo en true el retiro en local, modifico la direccion 
            setOrder({ ...order, pickup: _pickup, addressId: '', address: 'Retira en local', position: [] })
        } else {
            setOrder({ ...order, pickup: _pickup })
        }
    }

    const handleSendOrder = async () => {
        // This function is called when the main CTA button is clicked.
        setDisabled(true); // Disable button immediately

        if (order.paymentMethod === 'mercadopago') {
            // If MP is selected, calling sendOrder (from props) will trigger
            // preference ID fetching in cartWithData.js.
            // The Wallet brick will appear once mercadopagoPreferenceId is set.
            try {
                await sendOrder(order); // This now initiates preference ID fetch for MP
                // It doesn't complete the order yet for MP.
                // No need to setDisabled(false) here if Wallet takes over.
                // If pref ID fetch fails, error notification is handled in cartWithData.js
            } catch (error) {
                // Error is handled in cartWithData.js, but re-enable button if needed
                setDisabled(false);
            }
        } else if (order.paymentMethod === 'polarsh') {
            if (!user) {
                setNotificationOpen(true);
                setNotificationMessage('Debes iniciar sesión para utilizar este método de pago.');
                setSeverity('error');
                setDisabled(false); // Re-enable
                return;
            }
            await initiatePolarshPayment(order); // This will handle disabling/enabling itself
        } else {
            // For other payment methods (e.g., cash)
            sendOrder(order) // This is the original call that saves the order directly
                .then(() => {
                    // Success notification and navigation are handled in cartWithData.js
                    // No need to setDisabled(false) here as page will likely navigate away
                })
                .catch((err) => {
                    console.error('Error sending order (non-MP/Polarsh):', err);
                    setDisabled(false); // Re-enable button on error
                    setNotificationOpen(true);
                    setNotificationMessage('Error al enviar el pedido. Intente nuevamente.');
                    setSeverity('error');
                });
        }
    }

    const initiatePolarshPayment = async (currentOrder) => {
        setDisabled(true)
        try {
            const orderToSave = { ...currentOrder, orderState: 'Pago pendiente', paymentMethod: 'polarsh' }
            // Assuming sendOrder updates currentOrder with an ID or returns the updated order with an ID
            const orderId = await sendOrder(orderToSave)

            if (!orderId) {
                console.error('Order ID not found after saving.')
                setNotificationOpen(true)
                setNotificationMessage('Error al procesar el pedido, ID no encontrado.')
                setSeverity('error')
                setDisabled(false)
                return
            }

            const amount = currentOrder.amount
            const currency = businessInfo?.currency?.code || 'UYU'
            const token = await getCurrentUser().getIdToken()

            console.log(`llamo a polarsh/createPaymentOrder amount:${amount}, orderId:${orderId}`)

            // Call /api/polarsh/createPaymentOrder
            const createPaymentOrderResponse = await fetch(`${apiBaseUrl}/polarsh/createPaymentOrder`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ orderId, amount, currency }),
            })

            if (!createPaymentOrderResponse.ok) {
                const errorData = await createPaymentOrderResponse.json()
                throw new Error(errorData.error || 'Error al crear la orden de pago en Polarsh.')
            }

            const { paymentOrderId } = await createPaymentOrderResponse.json()

            // Call /api/polarsh/preference/:paymentOrderId
            const preferenceResponse = await fetch(`${apiBaseUrl}/polarsh/preference/${paymentOrderId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })

            if (!preferenceResponse.ok) {
                const errorData = await preferenceResponse.json()
                throw new Error(errorData.error || 'Error al obtener la preferencia de pago de Polarsh.')
            }

            const { init_point } = await preferenceResponse.json()

            window.location.href = init_point
        } catch (error) {
            console.error('Error en el proceso de pago con Polarsh:', error)
            setNotificationOpen(true)
            setNotificationMessage(error.message || 'Error en el proceso de pago. Intente nuevamente.')
            setSeverity('error')
            setDisabled(false)
        }
    }


    const loginRequired = () => {
        if (!user)
            return (
                <Grid item xs={12}>
                    <Typography align='center' style={{ fontSize: 20 }}>Debes
                        <Button variant="text" onClick={loginWithGoogle} style={{ textTransform: 'none', padding: '0 5 1 5' }}>
                            <Typography color="primary" style={{ fontSize: 20 }}>iniciar sesión</Typography>
                        </Button>
                        para poder concretar la compra.
                    </Typography>
                </Grid>
            )
    }

    const handleChangeSchedule = (date) => {
        // si date es mayor a la fecha actual, seteo scheduled en true
        const _date = moment(date)
        const _now = moment()
        const _scheduled = _date.isAfter(_now)
        // console.log('scheduled', _scheduled)

        setOrder({ ...order, date, scheduled: _scheduled })
    }

    // Polar Sh
    // TODO: implement polar sh methods

    return (
        <Grid container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
        >
            {
                getProductQty(lineToEdit) > 0 &&
                <OrderProductEdit
                    itemToEdit={lineToEdit}
                    order={order}
                    openForm={editLineOpen}
                    setOpenForm={setEditLineOpen}
                    onConfirm={handleConfirmLineEdit}
                >
                    <Grid
                        container
                        direction="column"
                        alignitems="center"
                        justify="center"
                        style={{ padding: '0px 0px 15px 0px' }}
                    >
                        <InputNumber
                            label='Cantidad'
                            value={getProductQty(lineToEdit)}
                            setValue={qty => setProductQty(lineToEdit, qty)}
                            enableSm={false}
                            width={'100%'}
                        />
                    </Grid>

                </OrderProductEdit>
            }
            <Dialog
                disableBackdropClick={false}
                message={dialog.message}
                fullWidth={true}
                maxWidth={dialog.maxWidth}
                open={dialog.open}
                setOpen={setDialogOpen}
                acceptText={'Si'}
                cancelText={'No'}
                obj={dialog.obj}
                acceptChanges={deleteProduct}
            />
            <Notification autoHideDuration={autoHideDuration} notificationOpen={notificationOpen} handleNotificationClose={() => setOpen(false)} severity={severity} notificationMessage={notificationMessage} />
            {
                loginRequired()
            }


            <Grid item xs={12}
                className={classes.listContainer}
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
            >
                {
                    order.productsList?.length === 0 ?
                        <Typography align='center' style={{ width: '100%', padding: 50 }}>No has añadido comida aún.</Typography>
                        :
                        <List className={classes.list}>
                            {
                                order.productsList?.map((product, i) =>
                                    <ListItem key={product.id} className={classes.listItem}>
                                        {/* <ListItemAvatar>
                                            <Avatar alt={product.name} src={product.src} />
                                        </ListItemAvatar> */}
                                        <ListItemText
                                            disableTypography={true}
                                            primary={
                                                <Grid container alignItems="center" justify="center" style={{ overflowX: 'hidden' }}>
                                                    <Grid item xs={1} >
                                                        <Typography>
                                                            {product.qty}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={5} >
                                                        <Typography>
                                                            {`${product.name} `}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={3} container alignItems="center" justify="flex-end">
                                                        {`$${product.qty * product.price}`}
                                                    </Grid>
                                                    <Grid item xs={3} container direction="row" justify="flex-end">
                                                        <Grid item xs={6}>
                                                            <IconButton color="primary" aria-label="Editar" onClick={e => handleEditProduct(product)}>
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <IconButton color="secondary" aria-label="Eliminar" onClick={e => handleDeleteProduct(product)}>
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={1}>

                                                    </Grid>
                                                    <Grid item xs={11}>
                                                        <SmartNotes smartNotes={product.smartNotes} typographyColor='textSecondary' />
                                                    </Grid>
                                                </Grid>
                                            }
                                        />
                                    </ListItem>
                                )
                            }
                        </List>
                }
            </Grid>
            <Grid item xs={12}
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
            >
                <Grid item xs={12}>
                    <TextField multiline rows={3} variant="outlined" name="notes" id="notes" value={order.notes || ''} onChange={e => setOrder({ ...order, notes: e.target.value?.toUpperCase() })} label="Comentarios para la entrega" size="small" className={classes.input} placeholder='Ejemplo: Casa con rejas verdes' />
                </Grid>

                <Grid item xs={12} style={{ marginBottom: 0, marginTop: 15 }}>
                    <Grid item xs={12}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={12} md={4} >
                            <FormControl style={{ width: '100%' }} disabled={order.pickup || !user}>
                                <InputLabel id="address-label">Dirección de entrega</InputLabel>
                                <Select
                                    labelId="address-label"
                                    id="address"
                                    value={selectedAddress}
                                    onChange={handleChangeAddress}
                                >
                                    {
                                        addresses.map(el => <MenuItem key={el.id} value={el.id}>{`${el.address} ${el.number || ''}`}</MenuItem>)
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Button variant="outlined" onClick={() => setOpenAddressForm(true)} color="primary" disabled={order.pickup || !user}>Nueva dirección</Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 30, marginTop: 15 }}>
                    <PickupOptions visible={config?.pickupOption} pickup={order.pickup} setPickup={handleChangePickup} disabled={!user} />
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 0, marginTop: 15 }}>
                    <ScheduleOrder
                        visible={config?.canScheduleOrder || false}
                        date={order.date}
                        setDate={handleChangeSchedule}
                        businessInfo={businessInfo}
                        localOpen={localOpen}
                        isOpenSoon={isOpenSoon}
                        businessStatus={businessStatus}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography gutterBottom>Pagar con puntos</Typography>
                    <Slider onChange={changeUsedPoints} onChangeCommitted={changeUsedPointsCommited} defaultValue={order.usedPoints || 0} min={0} max={calculateMax()} valueLabelDisplay="auto" aria-label="Default" />
                </Grid>
                {
                    order.usedPoints > 0 &&
                    <Grid item xs={12}>
                        <Typography>{`Descuento en puntos $${order.usedPoints || 0}`}</Typography>
                    </Grid>
                }
                <Grid item xs={12}>
                    <Typography>{`Envío $${order.pickup ? 0 : (order.deliveryPrice || 0)}`}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography>{`Total $${order.amount || 0}`}</Typography>
                </Grid>

                <Grid item xs={12} style={{ marginBottom: 15, marginTop: 30 }}>
                    <PaymentMethod
                        paymentMethods={paymentMethods?.filter(method => method.clientMode)}
                        method={order.paymentMethod}
                        setMethod={(paymentMethod) => {
                            // When payment method changes, if it's not MP, clear any existing MP pref ID
                            if (paymentMethod !== 'mercadopago' && mercadopagoPreferenceId && clearMercadoPagoPreferenceId) {
                                clearMercadoPagoPreferenceId();
                            }
                            setOrder({ ...order, paymentMethod });
                        }}
                    />
                </Grid>

                <Grid item xs={12}
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    {/* Main Action Button: Hidden if MP Wallet is active */}
                    {!(order.paymentMethod === 'mercadopago' && mercadopagoPreferenceId) && (
                        !user ?
                            loginRequired()
                            :
                            (client?.termsConditions) ?
                                <Button
                                    onClick={handleSendOrder}
                                    color="primary"
                                    variant="contained"
                                    disabled={disabled} // This disabled state is managed by various conditions
                                    className={classes.input}
                                >
                                    {/* Adjust button text based on payment method */}
                                    {order?.paymentMethod === 'polarsh' ? 'Proceder al pago con Polarsh' :
                                        order?.paymentMethod === 'mercadopago' ? 'Pagar con Mercado Pago' :
                                            'Enviar pedido'}
                                </Button>
                                :
                                <Link to='/termsConditions' className={classes.link}>
                                    <Button color="secondary" variant="outlined" className={classes.input}>Acepte los términos y condiciones para poder realizar su pedido</Button>
                                </Link>
                    )}
                </Grid>
            </Grid>

        </Grid>
    )
}


export default ClientOrderForm